import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { Alert, useMantineTheme } from '@mantine/core';
import type { ReactNode } from 'react';
import { Icon } from '../Spinner/Icon';
import type { AlertProps } from './AlertProps';

const AlertIcon = <Icon icon={faCircleCheck} />;

export function SuccessAlert(props: AlertProps): ReactNode {
	const icon = props.icon ?? AlertIcon;

	const theme = useMantineTheme();
	const baseColor = theme.colors.green[9];
	const backgroundColor = theme.colors.green[1];

	return (
		<Alert color={baseColor} bg={backgroundColor} variant="light" title={props.title} icon={icon}>
			{props.children}
		</Alert>
	);
}
